import React from "react";
import "./ActivityModal.css";

interface ActivityModalProps {
  isOpen: boolean;
  title: string;
  options: string[];
  selectedOption: string;
  selectedOptions?: string[];
  isMultiSelect?: boolean;
  readOnly?: boolean;
  hideSubmit?: boolean;
  onSelect: (option: string) => void;
  onMultiSelect?: (options: string[]) => void;
  onClose: () => void;
  onUpdate: () => void;
  loading?: boolean;
}

const ActivityModal: React.FC<ActivityModalProps> = ({
  isOpen,
  title,
  options,
  selectedOption,
  selectedOptions = [],
  isMultiSelect = false,
  readOnly = false,
  hideSubmit = false,
  onSelect,
  onMultiSelect,
  onClose,
  onUpdate,
  loading,
}) => {
  if (!isOpen) return null;

  const hasSelection = isMultiSelect
    ? selectedOptions.length > 0
    : Boolean(selectedOption);

  const handleOptionClick = (option: string) => {
    if (readOnly) return;

    if (!isMultiSelect) {
      onSelect(option);
      return;
    }

    const nextOptions = selectedOptions.includes(option)
      ? selectedOptions.filter((selected) => selected !== option)
      : [...selectedOptions, option];

    onMultiSelect?.(nextOptions);
  };

  return (
    <div className="activity-modal-overlay">
      <div className="activity-modal-content">
        <h3>{title}</h3>

        <div className="activity-option-list">
          {options.map((opt, idx) => (
            <button
              key={idx}
              type="button"
              aria-pressed={
                isMultiSelect
                  ? selectedOptions.includes(opt)
                  : selectedOption === opt
              }
              className={`activity-option-btn ${
                isMultiSelect ? "multi-select" : ""
              } ${
                (isMultiSelect
                  ? selectedOptions.includes(opt)
                  : selectedOption === opt)
                  ? "selected"
                  : ""
              } ${readOnly ? "read-only" : ""}`}
              onClick={() => handleOptionClick(opt)}
            >
              {opt}
            </button>
          ))}
        </div>

        <div className="activity-modal-actions">
          <button className="activity-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          {!hideSubmit && (
            <button
              className="activity-update-btn"
              onClick={onUpdate}
              disabled={!hasSelection || loading}
            >
              {loading ? "Submitting" : "Submit"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityModal;
